import React, { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

// Right-side slide-over panel. Always mounted so the open/close transition runs.
export default function Drawer({
  open, onClose, title, children,
}: { open: boolean; onClose: () => void; title: React.ReactNode; children: React.ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && open) onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <div className={`fixed inset-0 z-50 ${open ? '' : 'pointer-events-none'}`} aria-hidden={!open}>
      {/* overlay */}
      <div
        className={`absolute inset-0 bg-gray-900/30 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      {/* panel */}
      <div
        className={`absolute top-0 right-0 h-full w-full max-w-md bg-gray-50 shadow-2xl flex flex-col
          transition-transform duration-300 ease-out ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-white flex-shrink-0">
          <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2">{title}</h2>
          <button onClick={onClose} aria-label="Close"
            className="text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg w-8 h-8 flex items-center justify-center">
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{open && children}</div>
      </div>
    </div>
  );
}
